import { BooleanValue, StringValue } from '@coveo/bueno';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { isErrorResponse, } from '../../../api/commerce/commerce-api-client.js';
import { requiredNonEmptyString, validatePayload, } from '../../../utils/validate-payload.js';
import { buildPlanRequest, } from './plan-request-builder.js';
export const fetchRedirectUrl = createAsyncThunk('commerce/standaloneSearchBox/fetchRedirect', async (payload, { getState, rejectWithValue, extra: { apiClient, navigatorContext } }) => {
    validatePayload(payload, { id: new StringValue({ emptyAllowed: false }) });
    const state = getState();
    const request = buildPlanRequest(state, navigatorContext);
    const response = await apiClient.plan(request);
    if (isErrorResponse(response)) {
        return rejectWithValue(response.error);
    }
    return response.success.redirect || '';
});
export const registerStandaloneSearchBox = createAction('commerce/standaloneSearchBox/register', (payload) => validatePayload(payload, {
    id: requiredNonEmptyString,
    redirectionUrl: requiredNonEmptyString,
    overwrite: new BooleanValue({ required: false }),
}));
export const updateStandaloneSearchBoxRedirectionUrl = createAction('commerce/standaloneSearchBox/updateRedirectionUrl', (payload) => validatePayload(payload, {
    id: requiredNonEmptyString,
    redirectionUrl: requiredNonEmptyString,
}));
export const resetStandaloneSearchBox = createAction('commerce/standaloneSearchBox/reset', (payload) => validatePayload(payload, {
    id: requiredNonEmptyString,
}));
